import { render, staticRenderFns } from "./essay_flags.vue?vue&type=template&id=3f04c112&scoped=true&"
import script from "./essay_flags.vue?vue&type=script&lang=js&"
export * from "./essay_flags.vue?vue&type=script&lang=js&"
import style0 from "./essay_flags.vue?vue&type=style&index=0&id=3f04c112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04c112",
  null
  
)

export default component.exports